import React from "react";
import Head from "next/head";
import Link from "next/link";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Layout from "../components/Layout";
import Pic from "../components/Pic";
import Preview from "../components/Preview";
import css from "csstype";

const style: css.Properties = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    padding: "120px 0 80px",
};

const overview: css.Properties = {
    width: "100%",
    textAlign: "center",
    display: "block",
    marginBottom: "40px",
};

const Stories = () => (
    <>
        <Head>
            <title>Real TacBoard Events</title>
            <meta name="description" content="Featuring real weddings and events where photos were collected by TacBoard" />
            <link href="https://fonts.googleapis.com/css2?family=Cormorant&display=swap" rel="stylesheet" />
            <link rel="canonical" href="https://tacboard.com/stories" />
            <meta property="og:title" content="Wedding Stories by TacBoard" />
            <meta property="og:description" content="Featuring real TacBoard weddings, plus tips for planning your event" />
            <meta property="og:image" content="https://imagedelivery.net/uvaLOqv6E4g37MA5AJ8WJg/2f2913ae-2477-445e-3d40-2a0a5a0f3800/public" />
        </Head>

        <Layout>
            <Header />


            <div style={style}>
                <div style={overview}>
                    <h1>Real Weddings. Real Inspiration.</h1>

                    <p style={{padding: "0 16px",  maxWidth: "800px", textAlign: "center", margin: "0 auto"}}>Using TacBoard is a great start to crafting an amazing experience for yourself and all your wedding guests. Look here for even more inspiration for your wedding, party, or corporate event.</p>
                </div>
                <Preview>
                    <Link href="/stories/hybrid-wedding-5-tips">
                        <a>
                            <Pic
                                alt="bride and groom torsos"
                                src="https://imagedelivery.net/uvaLOqv6E4g37MA5AJ8WJg/77a77205-23de-41cd-6606-6f8a95cbca00"
                                originalWidth={1366}
                                originalHeight={768}
                                width={320}
                                height={320}
                                widths={[320, 640]}
                                sizes="320px"
                            />

                            <h2>5 Tips on How to Keep Your Guests Engaged at Your Hybrid Wedding</h2>
                        </a>
                    </Link>
                </Preview>

                <Preview>
                    <Link href="/stories/12-unique-ways-to-keep-your-wedding-guests-entertained">
                        <a>
                            <Pic
                                alt="outdoor reception table with confetti"
                                src="https://imagedelivery.net/uvaLOqv6E4g37MA5AJ8WJg/2f2913ae-2477-445e-3d40-2a0a5a0f3800"
                                originalWidth={5431}
                                originalHeight={3470}
                                width={320}
                                height={320}
                                widths={[320, 640]}
                                sizes="320px"
                            />

                            <h2>12 Unique Ways to Keep Your Weddings Guests Entertained</h2>
                        </a>
                    </Link>
                </Preview>

                <Preview>
                    <Link href="/stories/stately-wedding">
                        <a>
                            <Pic
                                alt="white cloth draped over a large bough with chairs in rows"
                                src="https://storage.googleapis.com/gallery-prod-tac-images/5a33e0f0ee7a48f0ae624641d9e4ee99.jpg"
                                originalWidth={1200}
                                originalHeight={1600}
                                width={320}
                                height={320}
                                widths={[320, 640]}
                                sizes="320px"
                            />

                            <h2>A Stately Wedding</h2>
                        </a>
                    </Link>
                </Preview>

                <Preview>
                    <Link href="/stories/all-outdoors">
                        <a>
                            <Pic
                                    alt="reception venue among palm trees"
                                    src="https://storage.googleapis.com/gallery-prod-tac-images/469292edbb80479b9b974afee80118d7.jpg"
                                    originalWidth={1600}
                                    originalHeight={704}
                                    width={320}
                                    height={320}
                                    widths={[320, 640]}
                                    sizes="320px"
                                />
                            <h2>The Schneely&#39;s All Outdoor Wedding</h2>
                        </a>
                    </Link>
                </ Preview>


            </div>

            <Footer noNav />
        </Layout>
    </>
);

export default Stories;
